import { render, staticRenderFns } from "./SingleClassifierDetails.vue?vue&type=template&id=ed9a3b04&scoped=true&"
import script from "./SingleClassifierDetails.vue?vue&type=script&lang=js&"
export * from "./SingleClassifierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9a3b04",
  null
  
)

export default component.exports